import { Star } from "lucide-react";
import { useState } from "react";
import { IconButton, Box } from "@mui/material";

interface StarRatingProps {
  value: number;
  onChange: (value: number) => void;
}

export function StarRating({ value, onChange }: StarRatingProps) {
  const [hoverValue, setHoverValue] = useState<number>(0);

  return (
    <Box sx={{ display: 'flex', gap: 0.5 }}>
      {[1, 2, 3, 4, 5].map((star) => (
        <IconButton
          key={star}
          onClick={() => onChange(star)}
          onMouseEnter={() => setHoverValue(star)}
          onMouseLeave={() => setHoverValue(0)}
          sx={{
            p: 0.5,
            '&:hover': {
              transform: 'scale(1.1)',
            },
            transition: 'transform 0.2s ease',
          }}
        >
          <Star
            style={{
              width: 32,
              height: 32,
              color: star <= (hoverValue || value) ? '#1976d2' : '#e0e0e0',
              fill: star <= (hoverValue || value) ? '#1976d2' : 'none',
            }}
          />
        </IconButton>
      ))}
    </Box>
  );
}
